import { api } from '../api';

export interface UsageMetric {
  used: number;
  total: number;
  rate: number;
}

export interface DashboardAlertItem {
  residentId: string;
  type: 'UNUSED' | 'SCORE_DROP';
  severity: string;
  message: string;
  roomNumber: string | null;
  name: string | null;
  patientCode: string | null;
}

export interface DashboardSummary {
  date: string;
  alerts: {
    total: number;
    critical: number;
    warning: number;
    top: DashboardAlertItem[];
  };
  actions: {
    unused: number;
    dropped: number;
    voiceUnlinked: number;
    total: number;
  };
  bgt: UsageMetric;
  voiceWellness: UsageMetric | null;
  sync: {
    lastSyncedAt: string | null;
    stale: boolean;
    voicecheckConnected: boolean;
  };
}

export interface DashboardTrendPoint {
  date: string;
  bgtAvgScore: number | null;
  bgtUsers: number;
  hearing: number | null;
  cognitive: number | null;
  /** 표시 극성 — 높을수록 평온 */
  stress: number | null;
  voiceUsers: number;
}

export interface DashboardTrend {
  days: number;
  points: DashboardTrendPoint[];
}

export interface DashboardActivityItem {
  type: string;
  occurredAt: string;
  summary: string;
  residentId: string | null;
  roomNumber: string | null;
  name: string | null;
}

/** 대시보드 요약 — 경보·조치 대상·사용률·동기화 상태를 한 번에 */
export async function getDashboardSummary(): Promise<DashboardSummary> {
  const res = await api.get<DashboardSummary>('/dashboard/summary');
  return res.data;
}

/** 시설 단위 일별 추이 (BGT 평균 + 보이스 3종) */
export async function getDashboardTrend(days = 28): Promise<DashboardTrend> {
  const res = await api.get<DashboardTrend>('/dashboard/trend', { params: { days } });
  return res.data;
}

/** 최근 입소자 변경 이력 */
export async function getDashboardActivity(limit = 8): Promise<DashboardActivityItem[]> {
  const res = await api.get<DashboardActivityItem[]>('/dashboard/activity', { params: { limit } });
  return res.data;
}
